const translations = {
    "about": {
        en: "about",
        pt: "sobre",
        es: "sobre"
    },
    "about us": {
        en: "about us",
        pt: "sobre nos",
        es: "sobre nosotros"
    },
    "budget": {
        en: "budget",
        pt: "orçamento",
        es: "presupuesto"
    },
    "portfolio": {
        en: "portfolio",
        pt: "portfólio",
        es: "cartera"
    },
    "policy privacy": {
        en: "policy privacy",
        pt: "política de privacidade",
        es: "política de privacidad"
    },
    "services": {
        en: "services",
        pt: "serviços",
        es: "servicios"
    },
    "clients": {
        en: "Clients",
        pt: "Clientes",
        es: "Clientes"
    },
    "contact": {
        en: "Contact",
        pt: "Contato",
        es: "Contacto"
    },
    "we transform ideas into digital reality": {
        en: "We transform ideas into digital reality",
        pt: "Transformamos ideias em realidade digital",
        es: "Transformamos ideas en realidad digital"
    },
    "modern, agile, and efficient web development.": {
        en: "Modern, agile, and efficient web development.",
        pt: "Desenvolvimento web moderno, ágil e eficiente.",
        es: "Desarrollo web moderno, ágil y eficiente."
    },
    "learn more": {
        en: "Learn More",
        pt: "Saiba Mais",
        es: "Saber Más"
    },
    "what is cervo digital?": {
        en: "What is Cervo Digital?",
        pt: "O que é a Cervo Digital?",
        es: "¿Qué es Cervo Digital?"
    },
    "we are an agency specialized in website development, web applications, and digital marketing.": {
        en: "We are an agency specialized in website development, web applications, and digital marketing.",
        pt: "Somos uma agência especializada em desenvolvimento de sites, aplicações web e marketing digital.",
        es: "Somos una agencia especializada en desarrollo de sitios web, aplicaciones web y marketing digital."
    },
    "we create innovative solutions for companies looking to grow in the digital environment.": {
        en: "We create innovative solutions for companies looking to grow in the digital environment.",
        pt: "Criamos soluções inovadoras para empresas que desejam crescer no ambiente digital.",
        es: "Creamos soluciones innovadoras para empresas que desean crecer en el entorno digital."
    },
    "our goals are:": {
        en: "Our goals are:",
        pt: "Nossos objetivos são:",
        es: "Nuestros objetivos son:"
    },
    "our services": {
        en: "Our Services",
        pt: "Nossos Serviços",
        es: "Nuestros Servicios"
    },
    "web development": {
        en: "Web Development",
        pt: "Desenvolvimento Web",
        es: "Desarrollo Web"
    },
    "modern and responsive websites for companies and professionals.": {
        en: "Modern and responsive websites for companies and professionals.",
        pt: "Sites modernos e responsivos para empresas e profissionais.",
        es: "Sitios web modernos y responsivos para empresas y profesionales."
    },
    "e-commerce": {
        en: "E-commerce",
        pt: "E-commerce",
        es: "E-commerce"
    },
    "complete and optimized virtual stores for online sales.": {
        en: "Complete and optimized virtual stores for online sales.",
        pt: "Lojas virtuais completas e otimizadas para vendas online.",
        es: "Tiendas virtuales completas y optimizadas para ventas online."
    },
    "web systems": {
        en: "Web Systems",
        pt: "Sistemas Web",
        es: "Sistemas Web"
    },
    "customized solutions to optimize your business processes.": {
        en: "Customized solutions to optimize your business processes.",
        pt: "Soluções sob medida para otimizar processos do seu negócio.",
        es: "Soluciones a medida para optimizar los procesos de su negocio."
    },
    "api integrations": {
        en: "API Integrations",
        pt: "Integrações API",
        es: "Integraciones API"
    },
    "automation and bots": {
        en: "Automation and Bots",
        pt: "Automatização e Bots",
        es: "Automatización y Bots"
    },
    "web scraping and bots": {
        en: "Web Scraping and Bots",
        pt: "Web scrapping e Robôs",
        es: "Web scraping y Bots"
    },
    "our clients": {
        en: "Our Clients",
        pt: "Nossos Clientes",
        es: "Nuestros Clientes"
    },
    "some of the companies that trusted cervo digital to turn their projects into reality.": {
        en: "Some of the companies that trusted Cervo Digital to turn their projects into reality.",
        pt: "Algumas das empresas que confiaram na Cervo Digital para transformar seus projetos em realidade.",
        es: "Algunas de las empresas que confiaron en Cervo Digital para hacer realidad sus proyectos."
    },
    "frequently asked questions": {
        en: "Frequently Asked Questions",
        pt: "Perguntas Frequentes",
        es: "Preguntas Frecuentes"
    },
    "what services does cervo digital offer?": {
        en: "What services does Cervo Digital offer?",
        pt: "Quais serviços a Cervo Digital oferece?",
        es: "¿Qué servicios ofrece Cervo Digital?"
    },
    "we offer website development, virtual stores, custom web systems, api integrations, automation, bots, and web scraping.": {
        en: "We offer website development, virtual stores, custom web systems, API integrations, automation, bots, and web scraping.",
        pt: "Oferecemos desenvolvimento de sites, lojas virtuais, sistemas web personalizados, integrações API, automatização, bots e web scraping.",
        es: "Ofrecemos desarrollo de sitios web, tiendas virtuales, sistemas web personalizados, integraciones API, automatización, bots y web scraping."
    },
    "how can i request a quote?": {
        en: "How can I request a quote?",
        pt: "Como posso solicitar um orçamento?",
        es: "¿Cómo puedo solicitar un presupuesto?"
    },
    "are the websites responsive?": {
        en: "Are the websites responsive?",
        pt: "Os sites desenvolvidos são responsivos?",
        es: "¿Los sitios web son responsivos?"
    },
    "do you integrate with apis?": {
        en: "Do you integrate with APIs?",
        pt: "Vocês fazem integração com APIs?",
        es: "¿Hacen integración con APIs?"
    },
    "contact us": {
        en: "Contact Us",
        pt: "Entre em Contato",
        es: "Contáctenos"
    },
    "address": {
        en: "Address",
        pt: "Endereço",
        es: "Dirección"
    },
    "all rights reserved.": {
        en: "All rights reserved.",
        pt: "Todos os direitos reservados.",
        es: "Todos los derechos reservados."
    },
    "your name*": {
        en: "Your Name*",
        pt: "Seu Nome*",
        es: "Su Nombre*"
    },
    "your email*": {
        en: "Your Email*",
        pt: "Seu E-mail*",
        es: "Su Correo Electrónico*"
    },
    "your phone number*": {
        en: "Your Phone Number*",
        pt: "Seu número de telefone*",
        es: "Su Número de Teléfono*"
    },
    "title*": {
        en: "Title*",
        pt: "Título*",
        es: "Título*"
    },
    "your message*": {
        en: "Your Message*",
        pt: "Sua Mensagem*",
        es: "Su Mensaje*"
    },
    "see more": {
        en: "see more",
        pt: "ver mais",
        es: "ver más"
    },
    "identity and innovation": {
        en: "Identity and innovation",
        pt: "Identidade e inovação",
        es: "Identidad e innovación"
    },
    "authority and recognition": {
        en: "Authority and recognition",
        pt: "Autoridade e reconhecimento",
        es: "Autoridad y reconocimiento"
    },
    "expansion and new opportunities": {
        en: "Expansion and new opportunities",
        pt: "Expansão e novas oportunidades",
        es: "Expansión y nuevas oportunidades"
    },
    "efficiency and added value": {
        en: "Efficiency and added value",
        pt: "Eficiência e valor agregado",
        es: "Eficiencia y valor agregado"
    },
    "we connect systems efficiently, ensuring secure and automated communication between platforms to optimize your processes.": {
        en: "We connect systems efficiently, ensuring secure and automated communication between platforms to optimize your processes.",
        pt: "Conectamos sistemas de forma eficiente, garantindo comunicação segura e automatizada entre plataformas para otimizar seus processos.",
        es: "Conectamos sistemas de manera eficiente, garantizando comunicación segura y automatizada entre plataformas para optimizar sus procesos."
    },
    "we create intelligent bots for repetitive tasks, improving productivity and reducing manual errors in various workflows.": {
        en: "We create intelligent bots for repetitive tasks, improving productivity and reducing manual errors in various workflows.",
        pt: "Criamos bots inteligentes para tarefas repetitivas, melhorando produtividade e reduzindo erros manuais em diversos fluxos de trabalho.",
        es: "Creamos bots inteligentes para tareas repetitivas, mejorando la productividad y reduciendo errores manuales en diversos flujos de trabajo."
    },
    "we extract web data accurately and in a structured manner, turning scattered information into valuable insights for your business.": {
        en: "We extract web data accurately and in a structured manner, turning scattered information into valuable insights for your business.",
        pt: "Extraímos dados da web de forma precisa e estruturada, transformando informações dispersas em insights valiosos para seu negócio.",
        es: "Extraemos datos de la web de manera precisa y estructurada, transformando información dispersa en conocimientos valiosos para su negocio."
    },
    "you can contact us through the form below, via whatsapp or at our automated budget.": {
        en: "You can contact us through the form below, via Whatsapp or at our Automated Budget.",
        pt: "Você pode entrar em contato através do formulário abaixo ou pelo WhatsApp.",
        es: "Puedes contactarnos a través del siguiente formulario, vía whatsapp o en nuestro presupuesto automatizado."
    },
    "yes, all our websites are designed to work perfectly on mobile devices, tablets, and desktops.": {
        en: "Yes, all our websites are designed to work perfectly on mobile devices, tablets, and desktops.",
        pt: "Sim, todos os nossos sites são projetados para funcionar perfeitamente em dispositivos móveis, tablets e desktops.",
        es: "Sí, todos nuestros sitios web están diseñados para funcionar perfectamente en dispositivos móviles, tabletas y escritorios."
    },
    "yes, we perform secure and efficient integrations between different platforms to optimize processes and improve system communication.": {
        en: "Yes, we perform secure and efficient integrations between different platforms to optimize processes and improve system communication.",
        pt: "Sim, realizamos integrações seguras e eficientes entre diferentes plataformas para otimizar processos e melhorar a comunicação de sistemas.",
        es: "Sí, realizamos integraciones seguras y eficientes entre diferentes plataformas para optimizar procesos y mejorar la comunicación de sistemas."
    },
    "what are the benefits of automation and bots?": {
        en: "What are the benefits of automation and bots?",
        pt: "Quais são as vantagens da automatização e dos bots?",
        es: "¿Cuáles son las ventajas de la automatización y los bots?"
    },
    "web scrapping and robots": {
        en: "Web scrapping and Robots",
        pt: "Web scrapping e Robos",
        es: "Web scrapping y Robots"
    },
    "automation and bots help reduce repetitive manual tasks, increase productivity, and minimize operational errors.": {
        en: "Automation and bots help reduce repetitive manual tasks, increase productivity, and minimize operational errors.",
        pt: "A automatização e os bots ajudam a reduzir tarefas manuais repetitivas, aumentar a produtividade e minimizar erros operacionais.",
        es: "La automatización y los bots ayudan a reducir tareas manuales repetitivas, aumentar la productividad y minimizar errores operativos."
    },
    "what is web scraping and how can it help me?": {
        en: "What is web scraping and how can it help me?",
        pt: "O que é web scraping e como ele pode me ajudar?",
        es: "¿Qué es web scraping y cómo puede ayudarme?"
    },
    "web scraping is the automated extraction of data from websites. It can be useful for collecting strategic information and improving market analysis.": {
        en: "Web scraping is the automated extraction of data from websites. It can be useful for collecting strategic information and improving market analysis.",
        pt: "Web scraping é a extração automatizada de dados de sites. Ele pode ser útil para coletar informações estratégicas e melhorar a análise de mercado.",
        es: "El web scraping es la extracción automatizada de datos de sitios web. Puede ser útil para recopilar información estratégica y mejorar el análisis de mercado."
    },
    "contact us to discuss your project.": {
        en: "Contact us to discuss your project.",
        pt: "Entre em contato conosco para discutir seu projeto.",
        es: "Póngase en contacto con nosotros para discutir su proyecto."
    },
    "development of customized digital solutions focused on real results.": {
        en: "Development of customized digital solutions focused on real results.",
        pt: "Desenvolvimento de soluções digitais personalizadas com foco em resultados reais.",
        es: "Desarrollo de soluciones digitales personalizadas y enfocadas en resultados reales."
    },
    "access instagram": {
        en: "access instagram",
        pt: "acessar instagram",
        es: "acceder a instagram"
    },
    "access whatsapp": {
        en: "access whatsapp",
        pt: "acessar whatsapp",
        es: "acceder a whatsapp"
    },
    "access facebook": {
        en: "access facebook",
        pt: "acessar facebook",
        es: "acceder a facebook"
    },
    "access youtube": {
        en: "access youtube",
        pt: "acessar youtube",
        es: "acceder a youtube"
    },
    "english": {
        en: "English",
        pt: "Inglês",
        es: "Inglés"
    },
    "spanish": {
        en: "Spanish",
        pt: "Espanhol",
        es: "Español"
    },
    "portuguese": {
        en: "Portuguese",
        pt: "Português",
        es: "Portugués"
    },
    "choose your language": {
        en: "Choose your language",
        pt: "Escolha seu idioma",
        es: "Elige tu idioma"
    },
    "you can submit again at": {
        en: "You can submit again at",
        pt: "Você pode enviar novamente em",
        es: "Puedes volver a enviar en"
    },
    "minutes and": {
        en: "minutes and",
        pt: "minutos e",
        es: "minutos y"
    },
    "seconds.": {
        en: "seconds.",
        pt: "segundos.",
        es: "segundos."
    },
    "message sent!": {
        en: "Message sent!",
        pt: "Mensagem enviada!",
        es: "¡Mensaje enviado!"
    },
    "message not sent!": {
        en: "Message not sent!",
        pt: "Mensagem não enviada!",
        es: "¡Mensaje no enviado!"
    },
    "send": {
        en: "Send",
        pt: "Enviar",
        es: "Enviar"
    },
    "forum for Fanfics Web Novels Brazil": {
        en: "Forum for Fanfics Web Novels Brazil",
        pt: "Fórum para Fanfics Web Novels Brasil",
        es: "Foro de Fanfics Novelas Web Brasil"
    },
    "Beauty Boutique perfume e-commerce": {
        en: "Beauty Boutique perfume e-commerce",
        pt: "E-commerce de perfumes Beauty Boutique",
        es: "Comercio electrónico de perfumes Beauty Boutique"
    },
    "Kairos Solar solar panel company single page": {
        en: "Kairos Solar solar panel company single page",
        pt: "Página única da empresa de paíneis solares Kairos Solar",
        es: "Página única de la empresa de paneles solares Kairos Solar"
    },
    "a forum dedicated to the community of writers and readers of fanfics and web novels in Brazil, allowing the exchange of ideas and stories.": {
        en: 'A forum dedicated to the community of writers and readers of fanfics and web novels in Brazil, allowing the exchange of ideas and stories.',
        pt: 'Um fórum dedicado à comunidade de escritores e leitores de fanfics e web novels no Brasil, permitindo a troca de ideias e histórias.',
        es: 'Un foro dedicado a la comunidad de escritores y lectores de fanfics y novelas web de Brasil, que permite el intercambio de ideas e historias.'
    },
    "an e-commerce specialized in the sale of perfumes, offering a variety of fragrances to its online customers.": {
        en: 'An e-commerce specialized in the sale of perfumes, offering a variety of fragrances to its online customers.',
        pt: 'Um e-commerce especializado na venda de perfumes, oferecendo uma variedade de fragrâncias para seus clientes online.',
        es: 'Un comercio electrónico especializado en la venta de perfumes, que ofrece una variedad de fragancias a sus clientes online.'
    },
    "a single page presentation of a company specialized in installing solar panels, highlighting its services and products.": {
        en: 'A single page presentation of a company specialized in installing solar panels, highlighting its services and products.',
        pt: 'Uma página única de apresentação de uma empresa especializada em instalação de painéis solares, destacando seus serviços e produtos.',
        es: 'Una sola página que presenta una empresa especializada en instalación de paneles solares, destacando sus servicios y productos.'
    },
    "see Privacy Policy": {
        en: 'See Privacy Policy',
        pt: 'Ver Política de Privacidade',
        es: 'Ver Política de Privacidad'
    },
    "restart": {
        en: 'restart',
        pt: 'recomeçar',
        es: 'empezar de nuevo'
    },
    "intro_1": {
        "en": "Before we start, I want to get to know you better.",
        "pt": "Antes de começarmos, quero conhecer você melhor.",
        "es": "Antes de comenzar, quiero conocerte mejor."
    },
    "What is your name?": {
        "en": "What is your name?",
        "pt": "Qual é o seu nome?",
        "es": "¿Cuál es tu nombre?"
    },
    "Alright ${name}, what is the email where we can send our proposal?": {
        "en": "Alright ${name}, what is the email where we can send our proposal?",
        "pt": "Certo ${name}, qual é o e-mail em que podemos enviar a nossa proposta?",
        "es": "Bien ${name}, ¿cuál es el correo electrónico al que podemos enviar nuestra propuesta?"
    },
    "Well ${name}, which of the categories below do you fit into?": {
        "en": "Well ${name}, which of the categories below do you fit into?",
        "pt": "Bem ${name}, qual das categorias abaixo você se enquadra?",
        "es": "Bien ${name}, ¿en cuál de las siguientes categorías encajas?"
    },
    "Personal request, for individuals.": {
        "en": "Personal request, for individuals.",
        "pt": "Demanda pessoal, para pessoa física.",
        "es": "Solicitud personal, para persona física."
    },
    "Business request, for legal entities.": {
        "en": "Business request, for legal entities.",
        "pt": "Demanda empresarial, para pessoa jurídica.",
        "es": "Solicitud empresarial, para persona jurídica."
    },
    "What service do you need?": {
        "en": "What service do you need?",
        "pt": "Que serviço você precisa?",
        "es": "¿Qué servicio necesitas?"
    },
    "I want my first website, I've never had one.": {
        "en": "I want my first website, I've never had one.",
        "pt": "Quero meu primeiro site, nunca tive um.",
        "es": "Quiero mi primer sitio web, nunca he tenido uno."
    },
    "My website is outdated, I want to modernize it.": {
        "en": "My website is outdated, I want to modernize it.",
        "pt": "Meu site está muito antigo, quero atualizá-lo e deixá-lo mais moderno.",
        "es": "Mi sitio web está muy anticuado, quiero actualizarlo y modernizarlo."
    },
    "I need some adjustments/improvements on my website.": {
        "en": "I need some adjustments/improvements on my website.",
        "pt": "Preciso de alguns ajustes/melhorias em meu site.",
        "es": "Necesito algunos ajustes/mejoras en mi sitio web."
    },
    "I want to optimize my website's SEO.": {
        "en": "I want to optimize my website's SEO.",
        "pt": "Quero otimizar o SEO do meu site.",
        "es": "Quiero optimizar el SEO de mi sitio web."
    },
    "I want a website.": {
        "en": "I want a website.",
        "pt": "Quero um site.",
        "es": "Quiero un sitio web."
    },
    "I want an e-commerce.": {
        "en": "I want an e-commerce.",
        "pt": "Quero um e-commerce.",
        "es": "Quiero un comercio electrónico."
    },
    "I want a custom web system.": {
        "en": "I want a custom web system.",
        "pt": "Quero um sistema web personalizado.",
        "es": "Quiero un sistema web personalizado."
    },
    "I need an API integration.": {
        "en": "I need an API integration.",
        "pt": "Preciso de uma integração com API(s).",
        "es": "Necesito una integración con API(s)."
    },
    "I'm looking for automation using a bot/robot.": {
        "en": "I'm looking for automation using a bot/robot.",
        "pt": "Estou procurando automação usando um bot/robô.",
        "es": "Estoy buscando automatización usando un bot/robot."
    },
    "I need to extract data from a portal automatically and consistently.": {
        "en": "I need to extract data from a portal automatically and consistently.",
        "pt": "Preciso extrair dados de um portal de forma automática e consistente.",
        "es": "Necesito extraer datos de un portal de forma automática y consistente."
    },
    "What is your company name? You may leave it blank if you prefer.": {
        "en": "What is your company name? You may leave it blank if you prefer.",
        "pt": "Qual o nome da sua empresa? Pode deixar em branco se preferir.",
        "es": "¿Cuál es el nombre de tu empresa? Puedes dejarlo en blanco si prefieres."
    },
    "Would you like to inform your company's website?": {
        "en": "Would you like to inform your company's website?",
        "pt": "Gostaria de informar o site da sua empresa?",
        "es": "¿Te gustaría informar el sitio web de tu empresa?"
    },
    "Perfect ${name}, regarding your company ${company_name}, would you say that:": {
        "en": "Perfect ${name}, regarding your company ${company_name}, would you say that:",
        "pt": "Perfeito ${name}, sobre a sua empresa ${company_name}, você diria que:",
        "es": "Perfecto ${name}, sobre tu empresa ${company_name}, dirías que:"
    },
    "It is a new company, with little time in operation or not yet operating.": {
        "en": "It is a new company, with little time in operation or not yet operating.",
        "pt": "É uma empresa nova, com pouco tempo de funcionamento ou ainda não está em operação.",
        "es": "Es una empresa nueva, con poco tiempo de funcionamiento o que aún no está operativa."
    },
    "It is a mature company, already in the market with a digital presence.": {
        "en": "It is a mature company, already in the market with a digital presence.",
        "pt": "É uma empresa madura, já está no mercado há algum tempo e com presença digital.",
        "es": "Es una empresa madura, ya está en el mercado y tiene presencia digital."
    },
    "It is an old company, but it has no digital presence.": {
        "en": "It is an old company, but it has no digital presence.",
        "pt": "É uma empresa com bastante tempo de casa, porém não tem uma presença digital.",
        "es": "Es una empresa con bastante tiempo, pero no tiene presencia digital."
    },
    "Okay, you're in the right place, we want to help you!": {
        "en": "Okay, you're in the right place, we want to help you!",
        "pt": "Ok, você está no lugar certo, queremos te ajudar!",
        "es": "¡Bien, estás en el lugar correcto, queremos ayudarte!"
    },
    "First of all, I'd like to explain that our prices and quotes are 100% customized and adapt to your demand, in both complexity and requirements.": {
        "en": "First of all, I'd like to explain that our prices and quotes are 100% customized and adapt to your demand, in both complexity and requirements.",
        "pt": "Antes de mais nada, gostaria de te explicar que nossos valores e orçamentos são 100% personalizados e se adequam à sua demanda, tanto em complexidade quanto em requisitos.",
        "es": "Antes que nada, me gustaría explicarte que nuestros valores y presupuestos son 100% personalizados y se adaptan a tu demanda, tanto en complejidad como en requisitos."
    },
    "The more details, the better.": {
        "en": "The more details, the better.",
        "pt": "Quanto mais detalhes, melhor.",
        "es": "Cuantos más detalles, mejor."
    },
    "To generate a quote, please present your idea below:": {
        "en": "To generate a quote, please present your idea below:",
        "pt": "Para podermos gerar um orçamento, por gentileza nos apresente a sua ideia abaixo:",
        "es": "Para poder generar un presupuesto, por favor preséntanos tu idea a continuación:"
    },
    "How soon do you need this service completed?": {
        "en": "How soon do you need this service completed?",
        "pt": "Em quanto tempo você precisa desse serviço finalizado?",
        "es": "¿En cuánto tiempo necesitas que se complete este servicio?"
    },
    "It's urgent, I need the service within 7 days.": {
        "en": "It's urgent, I need the service within 7 days.",
        "pt": "Tenho urgência, preciso do serviço em até 7 dias.",
        "es": "Es urgente, necesito el servicio en un máximo de 7 días."
    },
    "I need the service within 15 days.": {
        "en": "I need the service within 15 days.",
        "pt": "Estou necessitando do serviço em até 15 dias.",
        "es": "Necesito el servicio en un máximo de 15 días."
    },
    "It's not very urgent, we can work within 30 days.": {
        "en": "It's not very urgent, we can work within 30 days.",
        "pt": "Não é algo muito urgente, podemos trabalhar com 30 dias.",
        "es": "No es algo muy urgente, podemos trabajar con 30 días."
    },
    "It's still just an idea, so I'm not in a hurry. I want to focus on the details and follow the development.": {
        "en": "It's still just an idea, so I'm not in a hurry. I want to focus on the details and follow the development.",
        "pt": "É uma ideia ainda, logo não tenho muita pressa, quero focar nos detalhes e acompanhar o desenvolvimento.",
        "es": "Es solo una idea por ahora, así que no tengo prisa. Quiero enfocarme en los detalles y seguir el desarrollo."
    },
    "Very well ${name}, thank you for the information and for your time.": {
        "en": "Very well ${name}, thank you for the information and for your time.",
        "pt": "Muito bem ${name}, agradecemos pelas informações e pelo seu tempo.",
        "es": "Muy bien ${name}, agradecemos la información y tu tiempo."
    },
    "We now have enough information to start thinking about your quote.": {
        "en": "We now have enough information to start thinking about your quote.",
        "pt": "Já temos algumas informações e já podemos começar a pensar em nosso orçamento.",
        "es": "Ya tenemos suficiente información para comenzar a pensar en nuestro presupuesto."
    },
    "We'll get in touch as soon as possible via email or phone.": {
        "en": "We'll get in touch as soon as possible via email or phone.",
        "pt": "Entraremos em contato o mais rápido possível por meio de e-mail ou por seu contato telefônico.",
        "es": "Nos pondremos en contacto lo antes posible por correo electrónico o por teléfono."
    },
    "CervoDigital thanks you for getting in touch and wishes you an excellent day.": {
        "en": "CervoDigital thanks you for getting in touch and wishes you an excellent day.",
        "pt": "A CervoDigital agradece seu contato e deseja um excelente dia.",
        "es": "CervoDigital agradece tu contacto y te desea un excelente día."
    },
    "You will be redirected in a few seconds.": {
        "en": "You will be redirected in a few seconds.",
        "pt": "Você será redirecionado em alguns segundos.",
        "es": "Serás redirigido en unos segundos."
    },
    "Before we start, I want to get to know you better.": {
        "en": "Before we start, I want to get to know you better.",
        "pt": "Antes de começar, quero conhecê-lo melhor.",
        "es": "Antes de empezar, quiero conocerte mejor."
    },
    "email is invalid": {
        "en": "email is invalid",
        "pt": "e-mail é inválido",
        "es": "el correo electrónico no es válido"
    },
    "telephone number is invalid": {
        "en": "telephone number is invalid",
        "pt": "número de telefone é inválido",
        "es": "el número de teléfono no es válido"
    },
    "text is invalid": {
        "en": "text is invalid",
        "pt": "o texto é inválido",
        "es": "el texto no es válido"
    },
    "tell us more about your idea, 50 characters at least": {
        "en": "tell us more about your idea, 50 characters at least",
        "pt": "conte-nos mais sobre sua ideia, no mínimo 50 caracteres",
        "es": "cuéntanos más sobre tu idea, mínimo 50 caracteres"
    },
    "your full name is required": {
        "en": "your full name is required",
        "pt": "seu nome completo é obrigatório",
        "es": "se requiere su nombre completo"
    },
    "Personal demand, for individuals.": {
        "en": "Personal demand, for individuals.",
        "pt": "Demanda pessoal, para indivíduos.",
        "es": "Demanda personal, para individuos."
    },
    "Business demand, for companies.": {
        "en": "Business demand, for companies.",
        "pt": "Demanda empresarial, para empresas.",
        "es": "Demanda empresarial, para empresas."
    },
    "Would you like to share your company's website?": {
        "en": "Would you like to share your company's website?",
        "pt": "Gostaria de compartilhar o site da sua empresa?",
        "es": "¿Quieres compartir el sitio web de tu empresa?"
    },
    "Perfect ${name}, about your company ${company_name}, you would say that:": {
        "en": "Perfect ${name}, about your company ${company_name}, you would say that:",
        "pt": "Perfeito ${name}, sobre sua empresa ${company_name}, você diria que:",
        "es": "Perfecto ${name}, sobre tu empresa ${company_name}, dirías que:"
    },
    "It is a new company, recently started or not yet operating": {
        "en": "It is a new company, recently started or not yet operating",
        "pt": "É uma empresa nova, iniciada recentemente ou ainda não em operação",
        "es": "Es una empresa nueva, de reciente creación o que aún no está en funcionamiento."
    },
    "It is an established company, already in the market for some time with a digital presence": {
        "en": "It is an established company, already in the market for some time with a digital presence",
        "pt": "É uma empresa consolidada, já há algum tempo no mercado e com presença digital",
        "es": "Es una empresa consolidada, ya en el mercado desde hace tiempo y con presencia digital."
    },
    "It is a long-standing company, but it has no digital presence": {
        "en": "It is a long-standing company, but it has no digital presence",
        "pt": "É uma empresa antiga, mas não tem presença digital",
        "es": "Es una empresa de larga trayectoria, pero no tiene presencia digital"
    },
    "You will be redirected in": {
        "en": "You will be redirected in",
        "pt": "Você será redirecionado em",
        "es": "Serás redirigido en"
    },
    "seconds!": {
        "en": "seconds!",
        "pt": "segundos!",
        "es": "segundos!"
    },
    "Thank you": {
        "en": "Thank you",
        "pt": "Obrigado",
        "es": "Gracias"
    },
    "We've received your information and will get in touch as soon as possible.": {
        "en": "We've received your information and will get in touch as soon as possible.",
        "pt": "Recebemos suas informações e entraremos em contato o mais breve possível.",
        "es": "Hemos recibido tu información y nos pondremos en contacto contigo lo antes posible."
    },
    "You'll hear from us via email or phone shortly.": {
        "en": "You'll hear from us via email or phone shortly.",
        "pt": "Em breve entraremos em contato por e-mail ou telefone.",
        "es": "En breve nos pondremos en contacto con usted por correo electrónico o por teléfono."
    },
    "Back to Homepage": {
        "en": "Back to Homepage",
        "pt": "Voltar a página inicial",
        "es": "Volver a la página inicial"
    },
    "Want to know the price of a website?": {
        "en": "Want to know the price of a website?",
        "pt": "Quer saber o valor de um site?",
        "es": "¿Quieres saber el precio de un sitio web?"
    },
    "Simulate now and find out how much it costs to develop your project online.": {
        "en": "Simulate now and find out how much it costs to develop your project online.",
        "pt": "Simule agora mesmo e descubra quanto custa desenvolver seu projeto online.",
        "es": "Simula ahora y descubre cuánto cuesta desarrollar tu proyecto online."
    },
    "Use our interactive tool to get a personalized price estimate in seconds.": {
        "en": "Use our interactive tool to get a personalized price estimate in seconds.",
        "pt": "Use nossa ferramenta interativa para ter uma estimativa de preço personalizada em segundos.",
        "es": "Utilice nuestra herramienta interactiva para obtener un presupuesto personalizado en segundos."
    },
    "order budget": {
        "en": "order budget",
        "pt": "pedir orçamento",
        "es": "pedir presupuesto"
    },
    "This website uses cookies": {
        "en": "This website uses cookies",
        "pt": "Este site usa cookies",
        "es": "Este sitio web utiliza cookies"
    },
    "We use cookies to improve your browsing experience, personalize content and analyze traffic. By continuing, you agree to the use of cookies.": {
        "en": "We use cookies to improve your browsing experience, personalize content and analyze traffic. By continuing, you agree to the use of cookies.",
        "pt": "Utilizamos cookies para melhorar sua experiência de navegação, personalizar conteúdo e analisar o tráfego. Ao continuar, você concorda com o uso de cookies.",
        "es": "Utilizamos cookies para mejorar tu experiencia de navegación, personalizar el contenido y analizar el tráfico. Al continuar, aceptas el uso de cookies."
    },
    "Reject": {
        "en": "Reject",
        "pt": "Rejeitar",
        "es": "Rechazar"
    },
    "Accept": {
        "en": "Accept",
        "pt": "Aceitar",
        "es": "Aceptar"
    },
    "Who we are": {
        "en": "Who we are",
        "pt": "Quem somos",
        "es": "Quienes somos"
    },
    "We are Cervo Digital, a website development agency, committed to user privacy even without a CNPJ at the moment.": {
        "en": "We are Cervo Digital, a website development agency, committed to user privacy even without a CNPJ at the moment.",
        "pt": "Somos a Cervo Digital, uma agência de desenvolvimento de sites, comprometida com a privacidade dos usuários mesmo sem CNPJ no momento.",
        "es": "Somos Cervo Digital, una agencia de desarrollo de sitios web, comprometida con la privacidad del usuario incluso sin CNPJ en este momento."
    },
    "What is this policy?": {
        "en": "What is this policy?",
        "pt": "O que é esta política",
        "es": "¿Qué es esta política?"
    },
    "Explains how we collect, use and protect the personal data of website users.": {
        "en": "Explains how we collect, use and protect the personal data of website users.",
        "pt": "Explica como coletamos, usamos e protegemos os dados pessoais dos usuários do site.",
        "es": "Explica cómo recopilamos, usamos y protegemos los datos personales de los usuarios del sitio web."
    },
    "Data we collect": {
        "en": "Data we collect",
        "pt": "Dados que coletamos",
        "es": "Datos que recopilamos"
    },
    "Name, email, phone, selected language (when provided by you)": {
        "en": "Name, email, phone, selected language (when provided by you)",
        "pt": "Nome, e-mail, telefone, idioma selecionado (quando fornecidos por você)",
        "es": "Nombre, correo electrónico, teléfono, idioma seleccionado (cuando usted lo proporcione)"
    },
    "IP, browser of pages accessed (technical data)": {
        "en": "IP, browser of pages accessed (technical data)",
        "pt": "IP, navegador de páginas acessadas (dados técnicos)",
        "es": "IP, navegador de las páginas visitadas (datos técnicos)"
    },
    "Why we use your data": {
        "en": "Why we use your data",
        "pt": "Por que usamos seus dados",
        "es": "¿Por qué utilizamos sus datos?"
    },
    "Respond to requests and provide services": {
        "en": "Respond to requests and provide services",
        "pt": "Atender solicitações e prestar serviços",
        "es": "Responder a las solicitudes y prestar servicios"
    },
    "Improve website navigation": {
        "en": "Improve website navigation",
        "pt": "Melhorar a navegação no site",
        "es": "Mejorar la navegación del sitio web"
    },
    "Send communications if authorized": {
        "en": "Send communications if authorized",
        "pt": "Enviar comunicações, se autorizado",
        "es": "Enviar comunicaciones si está autorizado"
    },
    "Sharing": {
        "en": "Sharing",
        "pt": "Compartilhamento",
        "es": "Intercambio"
    },
    "We may share data with partners securely, only when necessary. We never sell data.": {
        "en": "We may share data with partners securely, only when necessary. We never sell data.",
        "pt": "Podemos compartilhar dados com parceiros de forma segura, apenas quando necessário. Nunca vendemos dados.",
        "es": "Podemos compartir datos con socios de forma segura, solo cuando sea necesario. Nunca vendemos datos."
    },
    "Your rights": {
        "en": "Your rights",
        "pt": "Seus direitos",
        "es": "Tus derechos"
    },
    "Access and correct your data": {
        "en": "Access and correct your data",
        "pt": "Acessar e corrigir seus dados",
        "es": "Acceder y corregir sus datos"
    },
    "Request deletion": {
        "en": "Request deletion",
        "pt": "Solicitar a exclusão",
        "es": "Solicitar eliminación"
    },
    "Revoke consent": {
        "en": "Revoke consent",
        "pt": "Revogar consentimento",
        "es": "Revocar el consentimiento"
    },
    "Security": {
        "en": "Security",
        "pt": "Segurança",
        "es": "Seguridad"
    },
    "We take technical measures to protect your data, but we recommend that you exercise caution when sharing information online.": {
        "en": "We take technical measures to protect your data, but we recommend that you exercise caution when sharing information online.",
        "pt": "Adotamos medidas técnicas para proteger seus dados, mas recomendamos cuidado ao compartilhar informações online.",
        "es": "Tomamos medidas técnicas para proteger sus datos, pero le recomendamos que tenga cuidado al compartir información en línea."
    },
    "We use cookies to improve your experience. You can disable them in your browser settings.": {
        "en": "We use cookies to improve your experience. You can disable them in your browser settings.",
        "pt": "Usamos cookies para melhorar sua experiência. Você pode desativá-los nas configurações do seu navegador.",
        "es": "Utilizamos cookies para mejorar tu experiencia. Puedes desactivarlas en la configuración de tu navegador."
    },
    "Updates": {
        "en": "Updates",
        "pt": "Atualizações",
        "es": "Actualizaciones"
    },
    "We may update this policy. Whenever we do, we will inform you on the website.": {
        "en": "We may update this policy. Whenever we do, we will inform you on the website.",
        "pt": "Podemos atualizar esta política. Sempre que isso ocorrer, informaremos no site.",
        "es": "Podemos actualizar esta política. Cuando lo hagamos, le informaremos en el sitio web."
    },
    "Contact": {
        "en": "Contact",
        "pt": "Contato",
        "es": "Contacto"
    },
    "Add 'https://' to your URL": {
        "en": "Add 'https://' to your URL",
        "pt": "Adicione 'https://' em sua URL",
        "es": "Añade 'https://' a tu URL"
    },
    "Last question about you. What is your phone number? Just in case we need to contact you regarding your quote": {
        "en": "Last question about you. What is your phone number? Just in case we need to contact you regarding your quote",
        "pt": "Última pergunta sobre você. Qual é o seu número de telefone? Caso precisemos entrar em contato com você sobre o seu orçamento.",
        "es": "Una última pregunta sobre usted. ¿Cuál es su número de teléfono? Por si necesitamos contactarle en relación con su cotización."
    },
    "invalid url": {
        "en": "invalid URL",
        "pt": "URL inválida",
        "es": "URL no válida"
    },
    "Type your phone number": {
        "en": "Type your phone number",
        "pt": "Digite seu número de telefone",
        "es": "Escribe tu número de teléfono"
    },
    "Select a Country": {
        "en": "Select a Country",
        "pt": "Selecione um país",
        "es": "Seleccione un país"
    },
    "of": {
        "en": "of",
        "pt": "de",
        "es": "de"
    }
    ,
    "a problem occurred, please try again": {
        "en": "a problem occurred, please try again",
        "pt": "ocorreu um problema, tente novamente",
        "es": "ocurrió un problema, por favor inténtelo de nuevo"
    },
    "email not send": {
        "en": "email not send",
        "pt": "e-mail não enviado",
        "es": "correo electrónico no enviado"
    },
    "email sent": {
        "en": "email sent",
        "pt": "e-mail enviado",
        "es": "correo electrónico enviado"
    },
    "email quota exceeded": {
        "en": "email sendings quota exceeded",
        "pt": "cota de envios de e-mail excedida",
        "es": "se superó la cuota de envios de correo electrónico"
    },
    "wait some seconds before sending an email again": {
        "en": "wait some seconds before sending an email again",
        "pt": "aguarde alguns segundos antes de enviar um e-mail novamente",
        "es": "espere unos segundos antes de volver a enviar un correo electrónico"
    },
    "fast": {
        "en": "fast",
        "pt": "rápido",
        "es": "rápido"
    },
    "aesthetic": {
        "en": "aesthetic",
        "pt": "estético",
        "es": "estético"
    },
    "flexible": {
        "en": "flexible",
        "pt": "flexível",
        "es": "flexible"
    },
    "secure": {
        "en": "secure",
        "pt": "seguro",
        "es": "seguro"
    },
    "get started": {
        "en": "get started",
        "pt": "começar",
        "es": "empezar"
    },
    "visit page": {
        "en": "visit page",
        "pt": "visitar página",
        "es": "visitar página"
    },
    "details": {
        "en": "details",
        "pt": "detalhes",
        "es": "detalles"
    },
    "landing page": {
        "en": "landing page",
        "pt": "landing page",
        "es": "landing page"
    },
    "website": {
        "en": "website",
        "pt": "website",
        "es": "sitio web"
    },
    "all": {
        "en": "all",
        "pt": "todos",
        "es": "todos"
    },
    "why choose us?": {
        "en": "why choose us?",
        "pt": "Por que nos escolher?",
        "es": "¿Por qué elegirnos?"
    },
    "Your Store Open 24/7": {
        "en": "Your Store Open 24/7",
        "pt": "Sua loja aberta 24 horas",
        "es": "Tu tienda abierta 24/7"
    },
    "Your business is open around the clock with a digital storefront, allowing you to reach and sell to customers anywhere, anytime.": {
        "en": "Your business is open around the clock with a digital storefront, allowing you to reach and sell to customers anywhere, anytime.",
        "pt": "Seu negócio aberto a todo momento, permitindo alcançar seus clientes e fazer vendas de qualquer lugar e hora.",
        "es": "Tu negocio está abierto las 24 horas con una tienda digital, lo que te permite llegar y vender a clientes en cualquier lugar y momento."
    },
    "Online Authority and Credibility": {
        "en": "Online Authority and Credibility",
        "pt": "Autoridade e Credibilidade Online",
        "es": "Autoridad y Credibilidad Online"
    },
    "We build a professional website that establishes trust and credibility, ensuring your brand stands out from the competition.": {
        "en": "We build a professional website that establishes trust and credibility, ensuring your brand stands out from the competition.",
        "pt": "Nós construímos seu site profissional que transmite confiança e credibilidade, reforçando e destacando a sua marca da concorrência.",
        "es": "Construimos un sitio web profesional que establece confianza y credibilidad, asegurando que tu marca se destaque de la competencia."
    },
    "Efficiency and Growth with Technology": {
        "en": "Efficiency and Growth with Technology",
        "pt": "Eficiência e Crescimento com Tecnologia",
        "es": "Eficiencia y Crecimiento con Tecnología"
    },
    "Our soluções de tecnologia personalizadas automatizam tarefas e otimizam processos, liberando você para focar no crescimento do seu negócio.": {
        "en": "Our personalized technology solutions automate tasks and optimize processes, freeing you to focus on growing your business.",
        "pt": "Nossas soluções de tecnologia personalizadas automatizam tarefas e otimizam processos, liberando você para focar no crescimento do seu negócio.",
        "es": "Nuestras soluciones tecnológicas personalizadas automatizan tareas y optimizan procesos, liberándote para que te centres en el crecimiento de tu negocio."
    },
    "Strategic Decisions with Data": {
        "en": "Strategic Decisions with Data",
        "pt": "Decisões Estratégicas com Dados",
        "es": "Decisiones Estratégicas con Datos"
    },
    "We provide powerful insights from valuable data collected from the web, helping you make smarter, data-driven decisions for your company's future.": {
        "en": "We provide powerful insights from valuable data collected from the web, helping you make smarter, data-driven decisions for your company's future.",
        "pt": "Fornecemos insights poderosos a partir de dados valiosos coletados da web, ajudando você a tomar decisões mais inteligentes e baseadas em dados para o futuro de sua empresa.",
        "es": "Ofrecemos insights poderosos a partir de datos valiosos recopilados de la web, ayudándote a tomar decisiones más inteligentes y basadas en datos para el futuro de tu empresa."
    },
    "testimonies": {
        "en": "Testimonies",
        "pt": "Depoimentos",
        "es": "Testimonios"
    },
    "frequent questions": {
        "en": "frequent questions",
        "pt": "perguntas frequentes",
        "es": "preguntas frecuentes"
    },
    "this section is your direct channel to connect with us.": {
        "en": "This section is your direct channel to connect with us.",
        "pt": "Esta seção é o seu canal direto para se conectar conosco.",
        "es": "Esta sección es tu canal directo para conectar con nosotros."
    },
    "or if you prefer:": {
        "en": "Or if you prefer:",
        "pt": "Ou se preferir:",
        "es": "O si lo prefieres:"
    },
    "click below to access our 'Automated Estimate with Bot' and start a conversation with our artificial intelligence to get a fast, personalized estimate for your project": {
        "en": "Click below to access our 'Automated Estimate with Bot' and start a conversation with our artificial intelligence to get a fast, personalized estimate for your project",
        "pt": "Clique abaixo para acessar nosso 'Orçamento Automatizado com Bot' e iniciar uma conversa com nossa inteligência artificial para obter uma estimativa rápida e personalizada do seu projeto.",
        "es": "Haz clic abajo para acceder a nuestro 'Presupuesto Automatizado con Bot' y comenzar una conversación con nuestra inteligencia artificial para obtener una estimación rápida y personalizada para tu proyecto."
    },
    "auto budget": {
        "en": "auto budget",
        "pt": "orçamento automático",
        "es": "presupuesto automático"
    },
    "dominate the digital world like a giant": {
        "en": "dominate the digital world like a Giant",
        "pt": "Domine o Mundo Digital como um Gigante",
        "es": "domina el mundo digital como un Gigante"
    },
    "with a powerful online presence, your brand becomes an unstoppable force. our services transform your idea into a robust digital platform, ensuring you achieve extraordinary results": {
        "en": "with a powerful online presence, your brand becomes an unstoppable force. our services transform your idea into a robust digital platform, ensuring you achieve extraordinary results",
        "pt": "Com uma presença online poderosa, sua marca se torna uma força imparável. Nossos serviços transformam sua ideia em uma plataforma digital robusta, garantindo que você alcance resultados extraordinários",
        "es": "con una poderosa presencia online, tu marca se convierte en una fuerza imparable. nuestros servicios transforman tu idea en una plataforma digital robusta, asegurando que logres resultados extraordinarios"
    },
    "logistics company operations manager": {
        "en": "logistics company operations manager",
        "pt": "Gerente de Operações de uma empresa de logística",
        "es": "gerente de operaciones de una empresa de logística"
    },
    "the automation solution they implemented completely changed our workflow. tasks that used to take hours are now done in minutes. with the time saved, our team can focus on strategic improvements, and the system's accuracy eliminated manual errors. it was an investment that paid for itself in less than a month.": {
        "en": "the automation solution they implemented completely changed our workflow. tasks that used to take hours are now done in minutes. with the time saved, our team can focus on strategic improvements, and the system's accuracy eliminated manual errors. it was an investment that paid for itself in less than a month.",
        "pt": "a solução de automação que eles implementaram mudou completamente nosso fluxo de trabalho. Tarefas que levavam horas agora são feitas em minutos. Com o tempo economizado, nossa equipe pode focar em melhorias estratégicas, e a precisão do sistema eliminou os erros manuais. Foi um investimento que se pagou em menos de um mês.",
        "es": "la solución de automatización que implementaron cambió por completo nuestro flujo de trabajo. las tareas que antes tomaban horas ahora se hacen en minutos. con el tiempo ahorrado, nuestro equipo puede centrarse en mejoras estratégicas, y la precisión del sistema eliminó los errores manuales. fue una inversión que se pagó en menos de un mes."
    },
    "owner of an architecture firm": {
        "en": "owner of an architecture firm",
        "pt": "Proprietária de um escritório de arquitetura",
        "es": "propietaria de un estudio de arquitectura"
    },
    "we needed a website that was more than just a portfolio; we wanted a platform that reflected our professionalism. they not only delivered an impeccable design, but also a tailor-made system for us to manage our projects. the result is a website that inspires confidence and puts us on a whole new level in the market.": {
        "en": "we needed a website that was more than just a portfolio; we wanted a platform that reflected our professionalism. they not only delivered an impeccable design, but also a tailor-made system for us to manage our projects. the result is a website that inspires confidence and puts us on a whole new level in the market.",
        "pt": "Precisávamos de um site que fosse mais do que um portfólio; queríamos uma plataforma que refletisse nosso profissionalismo. Eles não apenas entregaram um design impecável, mas também um sistema sob medida para gerenciarmos nossos projetos. O resultado é um site que inspira confiança e nos coloca em um nível totalmente novo no mercado",
        "es": "necesitábamos un sitio web que fuera más que un portafolio; queríamos una plataforma que reflejara nuestro profesionalismo. no solo entregaron un diseño impecable, sino también un sistema a medida para que gestionáramos nuestros proyectos. el resultado es un sitio web que inspira confianza y nos coloca en un nivel totalmente nuevo en el mercado."
    },
    "founder of an online fashion store": {
        "en": "founder of an online fashion store",
        "pt": "Fundador de uma loja de moda online",
        "es": "fundador de una tienda de moda online"
    },
    "my online store has never been so good. the e-commerce that the agency built for us is fast, elegant and, most importantly, easy for customers to navigate. our revenue has increased considerably in a short time and, for the first time, I feel I have a store that really works 24/7.": {
        "en": "my online store has never been so good. the e-commerce that the agency built for us is fast, elegant and, most importantly, easy for customers to navigate. our revenue has increased considerably in a short time and, for the first time, I feel I have a store that really works 24/7.",
        "pt": "Minha loja virtual nunca esteve tão bem. O e-commerce que a agência construiu para nós é rápido, elegante e, o mais importante, fácil para os clientes navegarem. Nosso faturamento aumentou consideravelmente em pouco tempo e, pela primeira vez, sinto que tenho uma loja que realmente trabalha 24/7.",
        "es": "mi tienda virtual nunca ha estado tan bien. el e-commerce que la agencia construyó para nosotros es rápido, elegante y, lo más importante, fácil de navegar para los clientes. nuestra facturación ha aumentado considerablemente en poco tiempo y, por primera vez, siento que tengo una tienda que realmente funciona 24/7."
    },
    "loading": {
        "en": "loading",
        "pt": "carregando",
        "es": "cargando"
    },
    "translation": {
        "en": "translation",
        "pt": "tradução",
        "es": "traducción"
    },
    "color mode": {
        "en": "color mode",
        "pt": "modo de cor",
        "es": "modo de color"
    },
    "Privacy Policy Summary": {
        "en": "Privacy Policy Summary",
        "pt": "Resumo da Política de Privacidade",
        "es": "Resumen de la política de privacidad"
    },
    "Download privacy policy": {
        "en": "Download privacy policy",
        "pt": "Baixar política de privacidade",
        "es": "Descargar política de privacidad"
    },
    "Informations": {
        "en": "Informations",
        "pt": "Informações",
        "es": "Informaciones"
    },
    "connect": {
        "en": "connect",
        "pt": "conectar",
        "es": "conectar"
    },
    "new update available. Do you want to upload to the latest version?": {
        "en": "new update available. Do you want to upload to the latest version?",
        "pt": "nova atualização disponível. Deseja atualizar para a versão mais recente?",
        "es": "nueva actualización disponible. ¿Quieres descargar la última versión?"
    },
    "maximum limit of 4000 characters reached.": {
        "en": "maximum limit of 4000 characters reached.",
        "pt": "limite máximo de 4000 caracteres atingido.",
        "es": "se alcanzó el límite máximo de 4000 caracteres."
    },
    "The action you attempted is not permitted. The Cervo Digital website does not support this operation.": {
        "en": "The action you attempted is not permitted. The Cervo Digital website does not support this operation.",
        "pt": "A ação que você tentou realizar não é permitida. O website da Cervo Digital não aceita essa operação.",
        "es": "La acción que intentaste no está permitida. El sitio web de Cervo Digital no admite esta operación."
    },
    "To continue using the site, please close the developer tools (DevTools).": {
        "en": "To continue using the site, please close the developer tools (DevTools).",
        "pt": "Para continuar a usar o site, por favor, feche as ferramentas de desenvolvedor (DevTools).",
        "es": "Para continuar usando el sitio, cierre las herramientas para desarrolladores (DevTools)."
    },
    "Invalid Action": {
        "en": "Invalid Action",
        "pt": "Ação Inválida",
        "es": "Acción no válida"
    },
    "dev tools are not allowed": {
        "en": "dev tools are not allowed",
        "pt": "dev tools não são permitidas",
        "es": "¡No se permiten dev tools"
    },
    "budget sent, thank you": {
        "en": "budget sent, thank you",
        "pt": "orçamento enviado, obrigado",
        "es": "presupuesto enviado, gracias"
    },
    "budget not sent, try again later or contact the support": {
        "en": "budget not sent, try again later or contact the support",
        "pt": "orçamento não enviado, tente novamente mais tarde ou entre em contato com o suporte",
        "es": "Presupuesto no enviado, inténtalo más tarde o contacta con el soporte"
    },
    "An error occurred": {
        "en": "An error occurred",
        "pt": "Ocorreu um erro",
        "es": "Se produjo un error"
    },
    "Don't worry! Your attempt to submit your quote failed, but the form has been **safely saved** and we have already notified our support team.": {
        "en": "Don't worry! Your attempt to submit your quote failed, but the form has been **safely saved** and we have already notified our support team.",
        "pt": "Não se preocupe! Sua tentativa de enviar o orçamento falhou, mas o formulário foi **salvo com segurança** e já notificamos a equipe de suporte.",
        "es": "¡No te preocupes! Tu intento de enviar tu cotización falló, pero el formulario se guardó **de forma segura** y ya notificamos a nuestro equipo de soporte."
    },
    "Our experts will take care of it and get back to you shortly.": {
        "en": "Our experts will take care of it and get back to you shortly.",
        "pt": "Nossos especialistas cuidarão disso e entrarão em contato em breve.",
        "es": "Nuestros especialistas le atenderán y se pondrán en contacto con usted en breve."
    },
    "opportunity": {
        "en": "opportunity",
        "pt": "oportunidade",
        "es": "oportunidad"
    },
    "The page you are looking for was not found!": {
        "en": "The page you are looking for was not found!",
        "pt": "A página que você procura não foi encontrada!",
        "es": "¡La página que estás buscando no fue encontrada!"
    },
    "We apologize for the inconvenience, but the page you're looking for doesn't exist in our system. Below are some helpful links:": {
        "en": "We apologize for the inconvenience, but the page you're looking for doesn't exist in our system. Below are some helpful links:",
        "pt": "Lamentamos o inconveniente mas a página que você buscou não existe em nosso sistema. Abaixo estão alguns links úteis:",
        "es": "Disculpe las molestias, pero la página que busca no existe en nuestro sistema. A continuación, encontrará algunos enlaces útiles:"
    },
    "Build your digital empire.": {
        "en": "Build your digital empire.",
        "pt": "Construa seu império digital.",
        "es": "Construye tu imperio digital."
    },
    "Every great empire begins with a vision. Tell us yours and get ready to watch your brand rise. We are here to shape your online presence into a digital masterpiece.": {
        "en": "Every great empire begins with a vision. Tell us yours and get ready to watch your brand rise. We are here to shape your online presence into a digital masterpiece.",
        "pt": "Todo grande império começa com uma visão. Conte-nos a sua e prepare-se para ver sua marca se erguer. Estamos aqui para moldar sua presença online em uma obra-prima digital.",
        "es": "Todo gran imperio comienza con una visión. Cuéntanos la tuya y prepárate para ver crecer tu marca. Estamos aquí para convertir tu presencia online en una obra maestra digital."
    },
    "success": {
        "en": "success",
        "pt": "sucesso",
        "es": "éxito"
    },
    "the title is too short, 20 letters are required at least": {
        "en": "the title is too short, 20 letters are required at least.",
        "pt": "o título é muito curta, são necessárias 20 letras pelo menos.",
        "es": "El título es demasiado corto, se requieren 20 letras al menos."
    },
    "the description is too short, 50 letters are required at least": {
        "en": "the description is too short, 50 letters are required at least.",
        "pt": "a descrição é muito curta, são necessárias 50 letras pelo menos.",
        "es": "La descripción es demasiado corta, se requieren 50 letras al menos."
    },
    "law": {
        "en": "law",
        "pt": "advocacia",
        "es": "abogacía"
    },
    "dentistry": {
        "en": "dentistry",
        "pt": "odontologia",
        "es": "odontología"
    },
    "beauty": {
        "en": "beauty",
        "pt": "beleza",
        "es": "belleza"
    },
    "catalog": {
        "en": "catalog",
        "pt": "catálogo",
        "es": "catálogo"
    },
    "scheduling": {
        "en": "scheduling",
        "pt": "agendamentos",
        "es": "programación"
    },
    "clinic & health": {
        "en": "clinic & health",
        "pt": "clínica e saúde",
        "es": "clínica y salud"
    }
};

export default translations;
